import { ComponentProps } from 'preact';
import { useRef } from 'preact/hooks';
import styles from './Input.module.css';

interface InputProps extends ComponentProps<'input'> {
  label?: string;
  hint?: string;
  error?: string;
}

export function Input({ label, hint, error, id, ...props }: InputProps) {
  // Generate a unique ID for the input if one isn't provided, to ensure the label is properly associated.
  const inputIdRef = useRef(
    id || `input-${Math.random().toString(36).slice(2, 10)}`,
  );

  return (
    <div className={styles.container}>
      {label && (
        <label className={styles.label} htmlFor={inputIdRef.current}>
          {label}
        </label>
      )}
      {hint && <span className={styles.hint}>{hint}</span>}
      <input
        className={`${styles.input} ${error ? styles.inputError : ''}`}
        id={inputIdRef.current}
        {...props}
      />
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
}
